export default __webpack_public_path__ + "static/media/benchmarking_1.145d6ae5.svg";